// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3jE-b","options":"AnswerScale_options__2L6Gb","selected":"AnswerScale_selected__2SLvd"};